import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

const Daftar = () => {
  let [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  function normalizePhoneNumber(phone) {
    // Hapus semua karakter kecuali angka
    phone = phone.replace(/\D/g, '');

    // Jika diawali dengan "0", ubah menjadi "62"
    if (phone.startsWith('0')) {
        phone = '62' + phone.slice(1);
    }

    // Jika diawali dengan "+62", hapus "+"
    if (phone.startsWith('+62')) {
        phone = phone.replace('+', '');
    }

    return phone;
}

  const handleDaftar = async (e) => {
    e.preventDefault();

    try {
      username = normalizePhoneNumber(username)
     
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/prosesdaftar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ phonenumber: username }),
      });

      if (!response.ok) {
        throw new Error("Gagal Megirim Permintaan soal");
      }
      const result =await response.json();
      console.log(result.message)
      setSuccessMessage(result.message); // Menampilkan pesan sukses
      setError('');
      navigate('/daftar/verifikasiotp', { state: { phonenumber: username } });
    } catch (error) {
      setError(error.response?.data?.message +error || 'Something went wrong');
      setSuccessMessage('');
    }
  };

  return (
     <>
          <Helmet>
            <title>Daftar Akun Griya Vidya</title>
          </Helmet>
    <div>
      <div className="auth-main">
        <div className="auth-wrapper v3">
          <div className="auth-form">
            <div className="card my-5">
              <div className="card-body">
                <a href="#" className="d-flex justify-content-center">
                  <img src="/assets/images/logogvfix.png" alt="image" width={200} className="img-fluid brand-logo" />
                </a>
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <div className="auth-header">
                      <h2 className="text-secondary mt-5"><b>Hi, Selamat Datang</b></h2>
                      <p className="f-16 mt-2">Silahkan Masukkan Nomor HP kamu, yang Aktif ya! Kode OTP akan Dikirim ke Nomor Hendpone Untuk Memverifikasi pengguna</p>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleDaftar}>
                
                  <div className="input-group"><span className="input-group-text">+62</span>
                    <input 
                      type="number"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)} 
                      className="form-control" 
                      id="floatingInput" 
                      placeholder="Nomor Hendpone" 
                    />
                  </div>
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Minta Kode OTP</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}
                <h5 className="d-flex justify-content-center">Sudah Memiliki Akun? <a href='/login'>Login</a></h5> 
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Daftar;
